import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify, {
    iconfont: "md"
});

export default new Vuetify({ iconfont: "md" });
